export const CaptchaLoader = function (siteKey) {
    let reCaptcha = null,
        scriptLoadingIsStarted = false;

    this.init = () => {

        return new Promise((resolve) => {

            if (scriptLoadingIsStarted) {
                waitForLoadScript(() => {
                    resolve();
                });
                return;
            }

            scriptLoadingIsStarted = true;

            let script = document.createElement('script');

            script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + siteKey);
            script.async = true;

            script.onload = () => {
                waitForLoadScript(() => {
                    reCaptcha = window.grecaptcha;
                    resolve();
                });
            };

            document.head.appendChild(script);

        });

    };

    function waitForLoadScript(callback) {

        if (window.grecaptcha === undefined) {
            setTimeout(() => {
                waitForLoadScript(callback);
            }, 25);
        } else {
            window.grecaptcha.ready(() => {
                callback();
            })
        }
    }

    this.getToken = async (action) => {
        await this.init();

        return reCaptcha.execute(siteKey, {action: action})
            .then(function (token) {
                return token
            });
    };
};

export default CaptchaLoader;
